import { render, staticRenderFns } from "./Ota.vue?vue&type=template&id=f090838c"
import script from "./Ota.vue?vue&type=script&lang=js"
export * from "./Ota.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports